// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ao_apply.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'ao_applyPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform highp sampler2D depthSampler;
uniform highp sampler2D aoSampler;
uniform highp sampler2D halfLinearDepthSampler;
uniform float aoStrength;
uniform vec2 inverseHalfResolution;
uniform mat4 invertedProjectionMatrix;
float linearizeDepth(float z) {
vec4 p = invertedProjectionMatrix * vec4(vUV * 2.0 - 1.0, z * 2.0 - 1.0, 1.0);
return p.z / p.w;
}
float getAo() {
float mainDepth = linearizeDepth(texelFetch(depthSampler, ivec2(gl_FragCoord.xy), 0).r);
vec2 downsampledBase = gl_FragCoord.xy / 2.0;
vec2 closestHalf = floor(downsampledBase);
float weightSum = 0.0;
vec2 bottomTexelUv = max(vec2(0.0), gl_FragCoord.xy - 2.0) / 2.0;
vec2 bottomBase = floor(bottomTexelUv);
vec2 bilinearBase = 1.0 - fract(bottomTexelUv);
const float upsamplingMaxDepthError = 0.15;
const float upsamplingDepthWeight = 3.0 / upsamplingMaxDepthError;
const float upsamplingConstantMix = 0.05;
const float upsamplingBilinearWeight = 2.0;
float ao = 0.0;
float debugDepthError = 0.0;
ivec2 buv = ivec2(bottomTexelUv);
vec4 sampleDepth;
sampleDepth.x = texelFetchOffset(halfLinearDepthSampler, buv, 0, ivec2(0, 0)).r;
sampleDepth.y = texelFetchOffset(halfLinearDepthSampler, buv, 0, ivec2(1, 0)).r;
sampleDepth.z = texelFetchOffset(halfLinearDepthSampler, buv, 0, ivec2(1, 1)).r;
sampleDepth.w = texelFetchOffset(halfLinearDepthSampler, buv, 0, ivec2(0, 1)).r;
vec4 depthErrorWeight = max(vec4(0.0), upsamplingMaxDepthError - abs(sampleDepth - vec4(mainDepth))) * upsamplingDepthWeight;
vec4 weight = depthErrorWeight + upsamplingConstantMix;
weight += upsamplingBilinearWeight * abs((vec4(0, 1, 1, 0) - bilinearBase.x) * (vec4(0, 0, 1, 1) - bilinearBase.y));
vec4 sampleAo;
sampleAo.x = texelFetchOffset(aoSampler, buv, 0, ivec2(0, 0)).r;
sampleAo.y = texelFetchOffset(aoSampler, buv, 0, ivec2(1, 0)).r;
sampleAo.z = texelFetchOffset(aoSampler, buv, 0, ivec2(1, 1)).r;
sampleAo.w = texelFetchOffset(aoSampler, buv, 0, ivec2(0, 1)).r;
weightSum = dot(vec4(1), weight);
ao = dot(weight, sampleAo);
ao /= weightSum;
ao = 1.0 - ao * aoStrength;
ao = max(0.0, ao);
return ao;
}
void main() {
gl_FragColor = vec4(vec3(getAo()), 1.0);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ao_applyPixelShader = { name, shader };
//# sourceMappingURL=ao_apply.fragment.js.map